var chunkMapping = {
	"2": [
		2002
	],
	"15": [
		4396
	],
	"30": [
		5030
	],
	"60": [
		4060
	],
	"134": [
		6134
	],
	"170": [
		5170
	],
	"188": [
		4188
	],
	"192": [
		6192
	],
	"201": [
		6201
	],
	"228": [
		228
	],
	"288": [
		288
	],
	"378": [
		2378
	],
	"392": [
		4392
	],
	"396": [
		1396
	],
	"454": [
		8454
	],
	"492": [
		4492
	],
	"740": [
		5740
	],
	"794": [
		5794
	],
	"810": [
		9810
	],
	"828": [
		6828
	],
	"935": [
		9935
	],
	"936": [
		7936
	],
	"964": [
		6964
	]
};
var idToExternalAndNameMapping = {
	"228": [
		"default",
		"./App",
		429
	],
	"288": [
		"default",
		"./Checklists",
		2590
	],
	"1396": [
		"default",
		"./Standards",
		881
	],
	"2002": [
		"default",
		"./HuntBoard",
		4142
	],
	"2378": [
		"default",
		"./Procurement",
		8801
	],
	"4060": [
		"default",
		"./Cashflow",
		1210
	],
	"4188": [
		"default",
		"./Billing",
		3286
	],
	"4392": [
		"default",
		"./SalesMarketing",
		5969
	],
	"4396": [
		"default",
		"./Workflows",
		4006
	],
	"4492": [
		"default",
		"./ClientProfitability",
		1428
	],
	"5030": [
		"default",
		"./TechPerformance",
		7483
	],
	"5170": [
		"default",
		"./VoiceAgentLab",
		6490
	],
	"5740": [
		"default",
		"./Payroll",
		394
	],
	"5794": [
		"default",
		"./PhoneApp",
		7089
	],
	"6134": [
		"default",
		"./EndpointState",
		8181
	],
	"6192": [
		"default",
		"./SupportChatbot",
		8923
	],
	"6201": [
		"default",
		"./BidVettingWorkbench",
		2775
	],
	"6828": [
		"default",
		"./Quotes",
		2654
	],
	"6964": [
		"default",
		"./Changelog",
		4714
	],
	"7936": [
		"default",
		"./Blink",
		7782
	],
	"8454": [
		"default",
		"./App",
		9215
	],
	"9810": [
		"default",
		"./AiOps",
		2775
	],
	"9935": [
		"default",
		"./PhoneAgentAdmin",
		9217
	]
};
var idToRemoteMap = {
	"228": [
		{
			"externalType": "script",
			"name": "bellwetherFormsRemote"
		}
	],
	"288": [
		{
			"externalType": "script",
			"name": "checklists"
		}
	],
	"1396": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"2002": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"2378": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"4060": [
		{
			"externalType": "script",
			"name": "cashflow"
		}
	],
	"4188": [
		{
			"externalType": "script",
			"name": "billing"
		}
	],
	"4392": [
		{
			"externalType": "script",
			"name": "salesMarketingRemote"
		}
	],
	"4396": [
		{
			"externalType": "script",
			"name": "workflows"
		}
	],
	"4492": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"5030": [
		{
			"externalType": "script",
			"name": "techPerformanceRemote"
		}
	],
	"5170": [
		{
			"externalType": "script",
			"name": "voiceAgentLabRemote"
		}
	],
	"5740": [
		{
			"externalType": "script",
			"name": "payroll"
		}
	],
	"5794": [
		{
			"externalType": "script",
			"name": "phoneAppRemote"
		}
	],
	"6134": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6192": [
		{
			"externalType": "script",
			"name": "supportChatbotRemote"
		}
	],
	"6201": [
		{
			"externalType": "script",
			"name": "aiOpsRemote"
		}
	],
	"6828": [
		{
			"externalType": "script",
			"name": "quotes"
		}
	],
	"6964": [
		{
			"externalType": "script",
			"name": "changelog"
		}
	],
	"7936": [
		{
			"externalType": "script",
			"name": "blink"
		}
	],
	"8454": [
		{
			"externalType": "script",
			"name": "qbrReport"
		}
	],
	"9810": [
		{
			"externalType": "script",
			"name": "aiOpsRemote"
		}
	],
	"9935": [
		{
			"externalType": "script",
			"name": "phoneAgentRemote"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"228": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 429,
		"remoteName": "bellwetherFormsRemote"
	},
	"288": {
		"shareScope": "default",
		"name": "./Checklists",
		"externalModuleId": 2590,
		"remoteName": "checklists"
	},
	"1396": {
		"shareScope": "default",
		"name": "./Standards",
		"externalModuleId": 881,
		"remoteName": ""
	},
	"2002": {
		"shareScope": "default",
		"name": "./HuntBoard",
		"externalModuleId": 4142,
		"remoteName": ""
	},
	"2378": {
		"shareScope": "default",
		"name": "./Procurement",
		"externalModuleId": 8801,
		"remoteName": ""
	},
	"4060": {
		"shareScope": "default",
		"name": "./Cashflow",
		"externalModuleId": 1210,
		"remoteName": "cashflow"
	},
	"4188": {
		"shareScope": "default",
		"name": "./Billing",
		"externalModuleId": 3286,
		"remoteName": "billing"
	},
	"4392": {
		"shareScope": "default",
		"name": "./SalesMarketing",
		"externalModuleId": 5969,
		"remoteName": "salesMarketingRemote"
	},
	"4396": {
		"shareScope": "default",
		"name": "./Workflows",
		"externalModuleId": 4006,
		"remoteName": "workflows"
	},
	"4492": {
		"shareScope": "default",
		"name": "./ClientProfitability",
		"externalModuleId": 1428,
		"remoteName": ""
	},
	"5030": {
		"shareScope": "default",
		"name": "./TechPerformance",
		"externalModuleId": 7483,
		"remoteName": "techPerformanceRemote"
	},
	"5170": {
		"shareScope": "default",
		"name": "./VoiceAgentLab",
		"externalModuleId": 6490,
		"remoteName": "voiceAgentLabRemote"
	},
	"5740": {
		"shareScope": "default",
		"name": "./Payroll",
		"externalModuleId": 394,
		"remoteName": "payroll"
	},
	"5794": {
		"shareScope": "default",
		"name": "./PhoneApp",
		"externalModuleId": 7089,
		"remoteName": "phoneAppRemote"
	},
	"6134": {
		"shareScope": "default",
		"name": "./EndpointState",
		"externalModuleId": 8181,
		"remoteName": ""
	},
	"6192": {
		"shareScope": "default",
		"name": "./SupportChatbot",
		"externalModuleId": 8923,
		"remoteName": "supportChatbotRemote"
	},
	"6201": {
		"shareScope": "default",
		"name": "./BidVettingWorkbench",
		"externalModuleId": 2775,
		"remoteName": "aiOpsRemote"
	},
	"6828": {
		"shareScope": "default",
		"name": "./Quotes",
		"externalModuleId": 2654,
		"remoteName": "quotes"
	},
	"6964": {
		"shareScope": "default",
		"name": "./Changelog",
		"externalModuleId": 4714,
		"remoteName": "changelog"
	},
	"7936": {
		"shareScope": "default",
		"name": "./Blink",
		"externalModuleId": 7782,
		"remoteName": "blink"
	},
	"8454": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 9215,
		"remoteName": "qbrReport"
	},
	"9810": {
		"shareScope": "default",
		"name": "./AiOps",
		"externalModuleId": 2775,
		"remoteName": "aiOpsRemote"
	},
	"9935": {
		"shareScope": "default",
		"name": "./PhoneAgentAdmin",
		"externalModuleId": 9217,
		"remoteName": "phoneAgentRemote"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}